import { render, staticRenderFns } from "./AreaDetail.vue?vue&type=template&id=aaddddfc&scoped=true"
import script from "./AreaDetail.vue?vue&type=script&lang=js"
export * from "./AreaDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaddddfc",
  null
  
)

export default component.exports